import { SERVICES_AN_ERROR_OCCURRED_LOADING } from 'common/constants/services/services';

export const SPREADSHEET_NOTES_GETTING_NOTES_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING('spreadsheet notes');
export const GET_SPREADSHEET_NOTES_KEY = 'GET_SPREADSHEET_NOTES_KEY';
